import { useMutation } from '@tanstack/react-query';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import { ERROR_DEFAULT } from 'src/messages/assets';
import useProjectSystem from '../systems/useProjectSystem';

const useRequestSeatAsLimitedEditorMutation = () => {
	const system = useProjectSystem();
	const snackbar = useSnackbarSystem();

	return useMutation( {
		mutationFn: ( { projectID }: { projectID: number } ) => system.requestSeatAsLimitedEditor( { projectID } ),
		onSuccess: () => {
			snackbar.showOutlinedSuccessMessage( {
				title: 'Request sent',
				information: 'Your account owner will be notified.'
			} );
		},
		onError: () => {
			snackbar.showErrorMessage( { title: ERROR_DEFAULT } );
		}
	} );
};

export default useRequestSeatAsLimitedEditorMutation;
